<template>
	<div class="form-template">
		
		<div v-for="element in formElements" :key="element.id">
			
			<!-- INPUT ELEMENT -->

			<div class="input-div"  v-if="element.type == 'input'">

				<input v-if="element.readonly" type="text" class="input" :placeholder="element.placeholder" v-model="element.model" @keyup="updateData()">
				<input v-else="element.readonly" readonly type="text" class="input readonly-background" :placeholder="element.placeholder" v-model="element.model" @keyup="updateData()">

				<span class="footer-input">{{ element.name }} | Символи: {{ countChars(element.model) }}</span>
			</div>

			<!-- TEXTAREA ELEMENT -->
			

			<div class="textarea-div" v-if="element.type == 'textarea'">

				<textarea class="textarea " v-if="element.readonly" :placeholder="element.placeholder" v-model="element.model" @keyup="updateData()"></textarea>
				<textarea class="textarea readonly-background" v-else  :placeholder="element.placeholder" readonly v-model="element.model" @keyup="updateData()"></textarea>

				<span class="footer-input"> {{ element.name }} | Символи: {{ countChars(element.model) }}</span>
			</div>

			<!-- SELECT ELEMENT -->

			<div class="input-div" v-if="element.type == 'select'">

				<select v-model="element.model" @change="updateData(element)">

					<option v-for="elementOption in element.options" v-bind:value="elementOption.value">
						{{ elementOption.text }}
					</option>
				</select>
				<span class="footer-input"> {{ element.name }} </span>
				
			</div>

			<!-- STATUC ELEMENT -->

			<div class="wrap" v-if="element.type == 'status'" >

				<input type="checkbox" class="" :id="'s'+element.id" v-model="element.model" @change="updateData(element)" />
				<br>
				<label class="" :for="'s'+element.id">{{element.name}}</label>
			</div>

			<!-- SALE ELEMENT -->


			<div class="wrap" v-if="element.type == 'sale'" >
				<input type="checkbox" class="checks" :id="'s'+element.id" v-model="element.model" @change="updateData(element)" />
				<label class="slider-v3" :for="'s'+element.id">{{element.name}}</label>
			</div>
			<HotelDatePicker v-if="element.type == 'date_start'"

			@check-in-changed="checkInChanged" @check-out-changed="checkOutChanged"  :showYear="true" :startingDateValue="new Date(new Date(dateStart))" :endingDateValue="new Date(new Date(dateEnd))"
			format="DD/MM/YYYY"

			>
		</HotelDatePicker>
		<span v-if="element.type == 'date_start'" class="footer-input"> Скидка ще бъде валидна</span>



	</div>



</div>
</template>
<script>
	import HotelDatePicker from 'vue-hotel-datepicker'

	export default {
		name: 'forms',
		props: {
			formElements: {
				type: Array,
				require: true,
			}
		},
		components: {
			HotelDatePicker
		},
		
		methods: {
			
			checkInChanged(val) {

				var i = 0;
				this.formElements.forEach(function(formElement) {

					if(formElement.name == 'date_start') {
						formElement.model = val
					}

					i++;
				});

				this.updateData();

			},
			checkOutChanged(val) {

				var i = 0;
				this.formElements.forEach(function(formElement) {

					if(formElement.name == 'date_end') {
						formElement.model = val
					}

					i++;
				});

				this.updateData();


			}, 

			countChars: function(str) {
				// return str.length
			},
			updateData(element) {
				this.$emit('exportMeta', this.formElements);
			},
			unix_timestamp(t)
			{
				var dt = new Date(t*1000);
				var d = dt.getDate();
				var m =  dt.getMonth();
				m++
				var y = dt.getFullYear();
				return m+ '/' + d  + '/' + y;  
			},
		},
		computed: {
			dateStart() {
				var el = this.formElements.filter(formElement => formElement.name == 'date_start')
				return el[0].model

			},
			dateEnd() {
				var el = this.formElements.filter(formElement => formElement.name == 'date_end')
				console.log(el[0].model)

				return el[0].model
				

			}
		}

	}
</script>

<style scoped>

.success-button {
	margin-left: 0!important;
	width: 80%;
}
.button-create {
	border-radius: 19px;
	padding: 4px 10px 6px;
	font-weight: 500;
	font-size: 14px;
	margin-left: 15px;
	border: 2px solid #1473e6;
	background: #1473e6 !important;
	color: #fff;
}
/*! CSS Used from: http://localhost:3000/css/create.css */
.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
a:hover{text-decoration:none;}
li{list-style:none;font-size:15px;}
.ml0{margin-left:0;}
ul{padding:0;}
.navigation-create{border-left:1px solid #e8e8e8;padding:0;}
.content-create-main-menu{width:76%;float:left;padding:25px 0;width: 87%;
	height: 86%;
	float: left;}
	.table-info-view {
		height: 100%;
	}
	.footer-info {
		text-align:center;
		border-top:1px solid #ddd;
		padding-top: 13px!important;
	}
	table-info-view {
		padding:0 15px;
	}

	.content-create-work-child-menu{width:13%;float:right;border-left:1px solid #e8e8e8;height:100%;}
	.content-create-work-child-menu-ul{text-align:center;}
	.content-create-work-child-menu-ul li{margin-top:10px;}
	.icon-a{padding:1px 6px;font-size:16px;color:#707070;border-radius:2px;}
	.icon-a:hover{background-color:#e1e1e1;border-color:#e1e1e1;color:#777;}
	.header-table{margin-top:5px;}
	.active{background-color:rgba(44,44,44,.06);}
	.ul-sidebar li{box-sizing:border-box;width:100%;border-radius:4px;font-size:14px;font-weight:400;font-style:normal;text-decoration:none;cursor:pointer;transition:background-color 125ms ease-out,color 125ms ease-out;}
	.ul-sidebar li a{background-color:transparent;color:#4b4b4b;display:inline-flex;min-height:32px;width:100%;padding:5px 12px;}
	.ul-sidebar li a:hover{background-color:rgba(44,44,44,.06);}
	.ul-sidebar li a i{padding-top:5px;padding-right:7px;}
	.content-place{padding:20px 0;}

	.empty-folder{text-align:center;padding-top:10%;}
	.empty-folder img{height:100px;}
	.content-empty-folder h3{font-size:28px;font-weight:300;line-height:1.3;color:#707070;}
	.content-empty-folder p{font-size:14px;font-weight:300;line-height:1.3;color:#707070;}


	/* ************* FORM ********************/
	select {
		display: block;
		font-size: 11px;
		color: rgb(193, 193, 193);
		display: block;
		width: 100%;
		font-size: 13px;
		height: 34px;
		line-height: 10px;
		border-width: 1px 0px;
		border-top: 1px solid transparent;
		border-bottom: 1px solid rgb(226, 226, 226);
		outline: none;
		color: #777;
		background:none;
	}
	option {
		display: block;
		width: 100%;
		font-size: 13px;
		height: 34px;
		line-height: 10px;
		border-width: 1px 0px;
		border-top: 1px solid transparent;
		border-bottom: 1px solid rgb(226, 226, 226);
		outline: none;
	}
	.form-template{
		padding:0 2%;
	}
	.input-div{
		margin-bottom:30px;width: 47.5%;float:left;margin-right:1.4%; 
		display: inline-block;
	}
	.input{
		color: #6c757d;
		font-size: 12px;
		margin: 0!important;display:block;width:100%;font-size:13px;height:34px;line-height:10px;border-width:1px 0px;border-top:1px solid transparent;border-bottom:1px solid rgb(226, 226, 226);outline:none
	}
	.textarea {  
		margin-top: 20px;
		color: #6c757d;
		font-size: 12px;
		display: block;
		width: 100%;
		border-radius: 2px ;
		padding: 10px;
		font-size: 13px;
		height: auto;
		min-height: 100px;
		line-height: 18px;
		border-width: 1px 0px;
		border-top: 1px solid transparent;
		border: 1px solid rgb(226, 226, 226);
		outline: none;}
		.footer-input{display:block;font-size:11px;color:rgb(193, 193, 193);    color: #006886;

			font-weight: 600;}


			input::placeholder { /* Chrome/Opera/Safari */
				color: #cacaca;
			}
			textarea::placeholder { /* Chrome/Opera/Safari */
				color: #cacaca;
			}


			/*html,body { height:100% }
			body { background:linear-gradient(#f7f7f7,#e0e0e0); margin:0 }*/
			.wrap {
				display: inline-block;
				margin-right: 20px;
			}
			.checks { position:absolute; left:-9999px }


			.slider-v3 {
				position: relative; display: block;
				width: 70px; height: 22px;
				cursor: pointer;
				border-radius: 1.5em;
				transition: 350ms;
				background: #ddd;
			}

			.slider-v3::after {
				position: absolute; content:'';
				width: 35px; height: 22px;
				top: 0; left: 0;
				border-radius: 1.5em;
				transition:
				width 200ms ease-out,
				height 300ms 50ms ease-in,
				top 300ms 50ms ease-in,
				left 250ms 50ms ease-in,
				background 300ms ease-in,
				box-shadow 300ms ease-in;
				background: #1473e6;
				box-shadow: 0 0 0 1.5em #f2f2f2 inset;
			}

			input:checked + .slider-v3::after {
				width: 35px; height: 22px;
				top: 0; left: 35px;
				background: #1473e6;
				box-shadow: 0 0 0 0 #f2f2f2 inset;
			}
			.readonly-background {
				background: rgb(235, 235, 228);
			}
		</style>



// WEBPACK FOOTER //
// src/components/app_modules/Forms.vue